export default __webpack_public_path__ + "static/media/39.1b9750b9.gif";